<template>
  <div class="ma-3">
    <v-card class="mt-6 pa-0" elevation="10">
      <v-toolbar class="mb-6" :color="$colors[0]" dark>
        <span class="pl-0">Gaz professionnel</span>
      </v-toolbar>
      <FourmulaireDeCotationGaz
        class="pa-4"
        @sendDataToParent="replireDataFromCotation"
      />
      <ListePropositionsGaz
        class="pa-4"
        v-if="Propositions.length > 0"
        :infosCompteurProps="infosCompteur"
        :marge="marge"
        :Propositions="Propositions"
        :SocieteData="SocieteData"
        :numCompteur="numCompteur"
        :typeCompteur="typeCompteur"
        :panel="panel"
        :fournisseurActuelle="fournisseurActuelle"
        :selected="selected"
        :listCompteur="listCompteur"
        :donnerCompteur="donnerCompteur"
        :id_historique_cotation="id_historique_cotation"
      />
    </v-card>
  </div>
</template>
<script>
import FourmulaireDeCotationGaz from "../../components/proposition-professionnels-gaz/newGazFormulaireProposition/newFormulaireGazPro.vue";
import ListePropositionsGaz from "../../components/proposition-professionnels-gaz/newGazFormulaireProposition/newListePropositionGazPro.vue";
import "./css/cotationPro.css";

import axios from "axios";
import dialogeModal from "../../components/ui/dialogeModal.vue";
export default {
  name: "demandeDeCotationGazPro",
  components: {
    FourmulaireDeCotationGaz,
    ListePropositionsGaz,
    dialogeModal,
  },
  data() {
    return {
      infosCompteur: null,
      Propositions: [],
      SocieteData: [],
      marge: null,
      numCompteur: null,
      typeCompteur: null,
      panel: [],
      fournisseurActuelle: null,
      selected: [],
      listCompteur: [],
      donnerCompteur: {},
      id_historique_cotation: null,
    };
  },
  async created() {
    var whoIam = "";
    await this.whoIAm(this.getToken("token")).then((data) => {
      whoIam = data;
    });
    if (whoIam == "noToken") {
      localStorage.removeItem("vendeurName");
      localStorage.removeItem("typeUser");
      localStorage.removeItem("token");
      this.$router.push("/login");
    } else {
      localStorage.setItem("typeUser", whoIam);
    }
  },
  methods: {
    replireDataFromCotation({
      infosCompteur,
      typeCompteur,
      Propositions,
      SocieteData,
      numCompteur,
      marge,
      fournisseurActuelle,
      selected,
      listCompteur,
      profilCompteur,
      consommationGlobal,
      dateDebut,
      id_historique_cotation
    }) {
      this.infosCompteur = infosCompteur;
      this.Propositions = Propositions;
      this.SocieteData = SocieteData;
      this.numCompteur = numCompteur;
      this.marge = marge;
      this.typeCompteur = typeCompteur;
      this.fournisseurActuelle = fournisseurActuelle;
      this.selected = selected;
      this.listCompteur = listCompteur;
      this.id_historique_cotation = id_historique_cotation;
      this.donnerCompteur = {
        dateDebut: dateDebut,
        typeCompteur: typeCompteur,
        profilCompteur: profilCompteur,
        consomationGlobale: consommationGlobal,
      };
    },
  },
};
</script>
